import { apply, call } from 'redux-saga/effects';

import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';
import {
  FormErrors,
  ServerFormErrors,
  getServerFormErrors,
} from '@core/FinalForm/getServerErrors';
import { PayloadActionWithPromiseMeta } from '@core/FinalForm/typedefs';
import { ResetPasswordPayload } from '@bus/auth/typedefs';

export function* resetPassword({
  payload,
  meta: { resolve, reject },
}: PayloadActionWithPromiseMeta<ResetPasswordPayload>) {
  try {
    const { values, params } = payload;

    const body: string = yield call(JSON.stringify, values);

    const response: Response = yield apply(api, api.post, [
      {
        endpoint: `auth/reset/${params.uidb64}/${params.token}`,
        body,
        unsafe: true,
      },
    ]);

    if (response.status === 400) {
      const errors: ServerFormErrors = yield call([response, 'json']);
      const formErrors: FormErrors = yield call(getServerFormErrors, errors);
      reject(formErrors);
      yield throwError(response);
    }

    if (!response.ok) {
      reject();
      yield throwError(response);
    }

    resolve();
  } catch (e) {
    yield handleError(e);
  }
}
